import { Layer, LayerType } from './layer';

export enum LocationType {
    local = 'local',
    external = 'external',
}

export enum ImageSubstitutionType {
    LocationLogo = 'LocationLogo',
    LocationMap = 'LocationMap',
}

export class BaseImageLayer extends Layer {
    public location: string | null = null;

    public locationType: LocationType = LocationType.local;

    public showPlaceholderOverlay = false;

    public substitutionType?: ImageSubstitutionType | null = null;

    public originalWidth = 0;

    public originalHeight = 0;

    public constructor(id: number, type: LayerType) {
        super(id, type);
    }
}

export class ImageLayer extends BaseImageLayer {
    public forceUserToProvideImage = false;

    public strictCropping?: boolean = true;

    public constructor(id: number) {
        super(id, LayerType.image);
    }
}

export function isImageLayer(layer: Layer): layer is ImageLayer {
    return layer.type === LayerType.image;
}
